

export function ConvertFloat() {

    function convertFloat(value) {
        if (typeof value ==='undefined') return '0';
        return parseFloat(String(value).includes(',')?String(value).replace('.','').replace(',','.'):String(value))
    }

    return {
        convertFloat
    }
}